const NewArivel = [
  {
    landingPageUrl:
      "Jeans/Roadster/Roadster-Men-Black-Slim-Fit-Mid-Rise-Jeans/7139461/buy",
    id: 7139461,
    product: "Roadster Men Black Slim Fit Mid-Rise Jeans",
    productName: "Roadster Men Black Slim Fit Mid-Rise Jeans",
    rating: 0,
    ratingCount: 0,
    discount: 900,
    brand: "Roadster",
    searchImage:
      "http://assets.myntassets.com/assets/images/7139461/2018/11/7/e611ed53-c1d6-4fa9-b4a6-eaf8d7bb5e7e1541566511748-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-1.jpg",
    effectiveDiscountPercentageAfterTax: 58,
    effectiveDiscountAmountAfterTax: 870,
    inventoryInfo: [
      {
        skuId: 31274041,
        label: "28",
        inventory: 46,
        available: true,
      },
      {
        skuId: 31274042,
        label: "30",
        inventory: 155,
        available: true,
      },
      {
        skuId: 31274043,
        label: "32",
        inventory: 269,
        available: true,
      },
      {
        skuId: 31274044,
        label: "34",
        inventory: 203,
        available: true,
      },
      {
        skuId: 31274045,
        label: "36",
        inventory: 94,
        available: true,
      },
    ],
    sizes: "28,30,32,34,36",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/e611ed53-c1d6-4fa9-b4a6-eaf8d7bb5e7e1541566511748-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/e611ed53-c1d6-4fa9-b4a6-eaf8d7bb5e7e1541566511748-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/244af56a-374c-4638-a1e2-8c5d11d94cba1541566511662-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/3cf14655-6015-468a-af74-32f107e487a11541566511703-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/97a7d01c-7ac5-435b-99ed-09ab199a6de21541566511681-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/9b82d554-5810-437f-a34a-15b08a4647631541566511721-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(60% OFF)",
    additionalInfo: "Men Slim Fit Jeans",
    category: "Jeans",
    mrp: 1499,
    price: 599,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1541030400000",
    season: "Fall",
    year: "2018",
    systemAttributes: [],
  },
  {
    landingPageUrl: "Flip-Flops/Puma/Puma-Men-Black-Solid-Sliders/6816007/buy",
    id: 6816007,
    product: "Puma Men Black Solid Sliders",
    productName: "Puma Men Black Solid Sliders",
    rating: 0,
    ratingCount: 0,
    discount: 1500,
    brand: "Puma",
    searchImage:
      "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3a3279c9-abce-4b96-8864-d7235517b2711530602893936-Leadcat-5701530602892202-1.jpg",
    effectiveDiscountPercentageAfterTax: 58,
    effectiveDiscountAmountAfterTax: 1450,
    inventoryInfo: [
      {
        skuId: 30627112,
        label: "UK6",
        inventory: 95,
        available: true,
      },
      {
        skuId: 30627113,
        label: "UK7",
        inventory: 160,
        available: true,
      },
      {
        skuId: 30627114,
        label: "UK8",
        inventory: 229,
        available: true,
      },
      {
        skuId: 30627115,
        label: "UK9",
        inventory: 261,
        available: true,
      },
      {
        skuId: 30627116,
        label: "UK10",
        inventory: 193,
        available: true,
      },
      {
        skuId: 30627117,
        label: "UK11",
        inventory: 83,
        available: true,
      },
    ],
    sizes: "6,7,8,9,10,11",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3a3279c9-abce-4b96-8864-d7235517b2711530602893936-Leadcat-5701530602892202-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3a3279c9-abce-4b96-8864-d7235517b2711530602893936-Leadcat-5701530602892202-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/5c19184a-3dc4-45b3-a475-bb5e04049b0f1530602893876-Leadcat-5701530602892202-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/930ad3d2-548e-492f-950e-5d7d161b39841530602893908-Leadcat-5701530602892202-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/9345113b-bae9-402a-9a47-98349e3f031f1530602893890-Leadcat-5701530602892202-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3d184556-6b6b-4495-b6e0-edd4fac08cd41530602893923-Leadcat-5701530602892202-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(60% OFF)",
    additionalInfo: "Men Solid Sliders",
    category: "Flip Flops",
    mrp: 2499,
    price: 999,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1530144000000",
    season: "Fall",
    year: "2018",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Kurtas/Vishudh/Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta/2110558/buy",
    id: 2110558,
    product: "Vishudh Women Black & Gold-Toned Printed Straight Kurta",
    productName: "Vishudh Women Black & Gold-Toned Printed Straight Kurta",
    rating: 0,
    ratingCount: 0,
    discount: 575,
    brand: "Vishudh",
    searchImage:
      "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167748-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-1.jpg",
    effectiveDiscountPercentageAfterTax: 48,
    effectiveDiscountAmountAfterTax: 546,
    inventoryInfo: [
      {
        skuId: 14198620,
        label: "S",
        inventory: 678,
        available: true,
      },
      {
        skuId: 14198621,
        label: "M",
        inventory: 989,
        available: true,
      },
      {
        skuId: 14198622,
        label: "L",
        inventory: 1115,
        available: true,
      },
      {
        skuId: 14198623,
        label: "XL",
        inventory: 1172,
        available: true,
      },
      {
        skuId: 14198624,
        label: "XXL",
        inventory: 854,
        available: true,
      },
    ],
    sizes: "S,M,L,XL,XXL",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167748-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167748-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-1.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167681-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167722-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167643-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-4.jpg",
      },
    ],
    gender: "Women",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(50% OFF)",
    additionalInfo: "Printed Straight Kurta",
    category: "Kurtas",
    mrp: 1149,
    price: 574,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1504742400000",
    season: "Winter",
    year: "2017",
    systemAttributes: [
      {
        attribute: "SA_XT_Trending",
        value: "TRENDING",
      },
    ],
  },
  {
    landingPageUrl:
      "Casual-Shoes/Mactree/Mactree-Men-Black-Sneakers/9620463/buy",
    id: 9620463,
    product: "Mactree Men Black Sneakers",
    productName: "Mactree Men Black Sneakers",
    rating: 0,
    ratingCount: 0,
    discount: 1190,
    brand: "Mactree",
    searchImage:
      "http://assets.myntassets.com/assets/images/productimage/2019/5/10/7cb3f96a-c680-494e-ae4a-0bd1963805fb1557442938198-1.jpg",
    effectiveDiscountPercentageAfterTax: 69,
    effectiveDiscountAmountAfterTax: 1165,
    inventoryInfo: [
      {
        skuId: 34310215,
        label: "UK6",
        inventory: 738,
        available: true,
      },
      {
        skuId: 34310216,
        label: "UK7",
        inventory: 920,
        available: true,
      },
      {
        skuId: 34310217,
        label: "UK8",
        inventory: 836,
        available: true,
      },
      {
        skuId: 34310218,
        label: "UK9",
        inventory: 824,
        available: true,
      },
      {
        skuId: 34310219,
        label: "UK10",
        inventory: 610,
        available: true,
      },
    ],
    sizes: "6,7,8,9,10",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/7cb3f96a-c680-494e-ae4a-0bd1963805fb1557442938198-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/7cb3f96a-c680-494e-ae4a-0bd1963805fb1557442938198-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/b4e03c15-99db-4fad-8031-19679cea00e11557442938289-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/79a38e22-2b4f-45ff-9449-623df84efdfd1557442938246-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/891c38bb-f230-4a2f-a889-f039e9050cf31557442938219-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/cceaaf84-ff81-4077-a566-b0dcff0253561557442938266-4.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(70% OFF)",
    additionalInfo: "Men Sneakers",
    category: "Casual Shoes",
    mrp: 1699,
    price: 509,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1557360000000",
    season: "Spring",
    year: "2019",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Sweatshirts/Campus-Sutra/Campus-Sutra-Men-Black--Grey-Colourblocked-Hooded-Sweatshirt/10381447/buy",
    id: 10381447,
    product: "Campus Sutra Men Black & Grey Colourblocked Hooded Sweatshirt",
    productName:
      "Campus Sutra Men Black & Grey Colourblocked Hooded Sweatshirt",
    rating: 0,
    ratingCount: 0,
    discount: 880,
    brand: "Campus Sutra",
    searchImage:
      "http://assets.myntassets.com/assets/images/10381447/2019/8/16/3aaf0f72-0cf4-40ef-a36c-c81e3186c3281565956541245-Campus-Sutra-Men-Sweatshirts-2091565956539708-1.jpg",
    effectiveDiscountPercentageAfterTax: 53,
    effectiveDiscountAmountAfterTax: 844,
    inventoryInfo: [
      {
        skuId: 35459783,
        label: "S",
        inventory: 743,
        available: true,
      },
      {
        skuId: 35459791,
        label: "M",
        inventory: 348,
        available: true,
      },
      {
        skuId: 35459795,
        label: "L",
        inventory: 565,
        available: true,
      },
      {
        skuId: 35459799,
        label: "XL",
        inventory: 745,
        available: true,
      },
    ],
    sizes: "S,M,L,XL",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/3aaf0f72-0cf4-40ef-a36c-c81e3186c3281565956541245-Campus-Sutra-Men-Sweatshirts-2091565956539708-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/3aaf0f72-0cf4-40ef-a36c-c81e3186c3281565956541245-Campus-Sutra-Men-Sweatshirts-2091565956539708-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/aaf1e3b1-2d19-4efd-9d92-204d1612b5f31565956541174-Campus-Sutra-Men-Sweatshirts-2091565956539708-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/128f80d8-c789-4269-9f5e-d48e7ef882051565956541209-Campus-Sutra-Men-Sweatshirts-2091565956539708-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/d1f8718f-918c-4a31-b9da-9ee4062b54511565956541191-Campus-Sutra-Men-Sweatshirts-2091565956539708-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/d0ea905f-b05b-4838-9f0a-32dd2f19433b1565956541227-Campus-Sutra-Men-Sweatshirts-2091565956539708-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(55% OFF)",
    additionalInfo: "Men Colourblocked Sweatshirt",
    category: "Sweatshirts",
    mrp: 1599,
    price: 719,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1565827200000",
    season: "Winter",
    year: "2019",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Kurta-Sets/Ahalyaa/Ahalyaa-Women-Black--Pink-Printed-Kurta-with-Palazzos/9689961/buy",
    id: 9689961,
    product: "Ahalyaa Women Black & Pink Printed Kurta with Palazzos",
    productName: "Ahalyaa Women Black & Pink Printed Kurta with Palazzos",
    rating: 0,
    ratingCount: 0,
    discount: 2318,
    brand: "Ahalyaa",
    searchImage:
      "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2ff8b66c-b9b0-4b17-8be6-6ab28a728fba1559027532069-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-1.jpg",
    effectiveDiscountPercentageAfterTax: 56,
    effectiveDiscountAmountAfterTax: 2140,
    inventoryInfo: [
      {
        skuId: 34363741,
        label: "S",
        inventory: 139,
        available: true,
      },
      {
        skuId: 34363742,
        label: "M",
        inventory: 161,
        available: true,
      },
      {
        skuId: 34363743,
        label: "L",
        inventory: 180,
        available: true,
      },
      {
        skuId: 34363744,
        label: "XL",
        inventory: 179,
        available: true,
      },
      {
        skuId: 34363745,
        label: "XXL",
        inventory: 189,
        available: true,
      },
    ],
    sizes: "S,M,L,XL,XXL",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2ff8b66c-b9b0-4b17-8be6-6ab28a728fba1559027532069-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2ff8b66c-b9b0-4b17-8be6-6ab28a728fba1559027532069-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-1.jpg",
      },
      {
        view: "top",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2bc35be8-4cfc-407a-8f63-1e73e2b1f1ba1559027531935-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-6.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/93f0364d-34b8-4218-89fc-561c16070c5c1559027531956-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/7037fb77-0f74-44af-94cb-4ba0300db4031559027532013-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/ef082d8f-017c-49de-b727-ac35a6d247e41559027532041-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/cc1354d3-4084-4ddf-b9be-ffb8127f5d4d1559027531981-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-4.jpg",
      },
    ],
    gender: "Women",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(61% OFF)",
    additionalInfo: "Women Printed Kurta with Palazzos",
    category: "Kurta Sets",
    mrp: 3799,
    price: 1481,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1558569600000",
    season: "Summer",
    year: "2019",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Jeans/HERENOW/HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans/9211679/buy",
    id: 9211679,
    product:
      "HERE&NOW Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    productName:
      "HERE&NOW Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    rating: 0,
    ratingCount: 0,
    discount: 1320,
    brand: "HERE&NOW",
    searchImage:
      "http://assets.myntassets.com/assets/images/9211679/2019/7/15/14f9566a-c584-4101-86f3-bc54a91d4cce1563190986058-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-1.jpg",
    effectiveDiscountPercentageAfterTax: 58,
    effectiveDiscountAmountAfterTax: 1276,
    inventoryInfo: [
      {
        skuId: 33916416,
        label: "28",
        inventory: 51,
        available: true,
      },
      {
        skuId: 33916418,
        label: "30",
        inventory: 104,
        available: true,
      },
      {
        skuId: 33916421,
        label: "32",
        inventory: 69,
        available: true,
      },
      {
        skuId: 33916423,
        label: "34",
        inventory: 13,
        available: true,
      },
      {
        skuId: 33916425,
        label: "36",
        inventory: 13,
        available: true,
      },
    ],
    sizes: "28,30,32,34,36",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/14f9566a-c584-4101-86f3-bc54a91d4cce1563190986058-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/14f9566a-c584-4101-86f3-bc54a91d4cce1563190986058-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-1.jpg",
      },
      {
        view: "top",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/79ee951f-4c4e-48c5-b6c4-91641909467d1563190985945-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-6.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/ad8cc0ef-2fa0-4bc3-aa27-5532ebbed7741563190985970-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-5.jpg",
      },
      {
        view: "bottom",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/659c12dc-8739-4ed1-9696-51c60eca31331563190985928-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-7.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/114bdd54-af07-495c-ad68-969d0b9073d11563190986011-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/802aaa6d-6fd9-40f2-b026-d2780fad08dc1563190985989-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/8eda8dab-5f45-4c09-80d6-4d417bfe34c61563190986036-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(60% OFF)",
    additionalInfo: "Men Slim Fit Jeans",
    category: "Jeans",
    mrp: 2199,
    price: 879,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1560384000000",
    season: "Summer",
    year: "2019",
    systemAttributes: [
      {
        attribute: "SA_XT_Trending",
        value: "TRENDING",
      },
    ],
  },
  {
    landingPageUrl:
      "Jeans/Roadster/Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans/7139482/buy",
    id: 7139482,
    product:
      "Roadster Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    productName:
      "Roadster Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    rating: 0,
    ratingCount: 0,
    discount: 450,
    brand: "Roadster",
    searchImage:
      "http://assets.myntassets.com/assets/images/7139482/2018/11/20/67238d5c-8749-47b5-a4e1-732aedc885d91542713378025-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-1.jpg",
    effectiveDiscountPercentageAfterTax: 22,
    effectiveDiscountAmountAfterTax: 324,
    inventoryInfo: [
      {
        skuId: 31274146,
        label: "28",
        inventory: 287,
        available: true,
      },
      {
        skuId: 31274147,
        label: "30",
        inventory: 289,
        available: true,
      },
      {
        skuId: 31274148,
        label: "32",
        inventory: 92,
        available: true,
      },
      {
        skuId: 31274149,
        label: "34",
        inventory: 25,
        available: true,
      },
      {
        skuId: 31274150,
        label: "36",
        inventory: 1,
        available: true,
      },
    ],
    sizes: "28,30,32,34,36",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/67238d5c-8749-47b5-a4e1-732aedc885d91542713378025-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/67238d5c-8749-47b5-a4e1-732aedc885d91542713378025-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-1.jpg",
      },
      {
        view: "top",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/595f1c50-a411-4a9d-b19c-18eb216878ea1542713377948-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-6.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/e9d42c7f-8f30-4aa1-abf2-e9473acdad7c1542713377961-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-5.jpg",
      },
      {
        view: "bottom",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/0572b7c4-7cc4-4f25-9413-76e8b2725a691542713377937-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-7.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/63837c12-619d-45fa-8670-17abd0c09ba11542713377996-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/c9deaae0-0f50-430d-abe0-214b8a589b931542713378012-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/3d37fb1a-4ce0-42e2-adc6-f7bfbad531691542713377979-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-4.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(30% OFF)",
    additionalInfo: "Men Slim Fit Jeans",
    category: "Jeans",
    mrp: 1499,
    price: 1049,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1542240000000",
    season: "Fall",
    year: "2018",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Jeans/Roadster/Roadster-Men-Black-Slim-Fit-Mid-Rise-Jeans/7139461/buy",
    id: 7139461,
    product: "Roadster Men Black Slim Fit Mid-Rise Jeans",
    productName: "Roadster Men Black Slim Fit Mid-Rise Jeans",
    rating: 0,
    ratingCount: 0,
    discount: 900,
    brand: "Roadster",
    searchImage:
      "http://assets.myntassets.com/assets/images/7139461/2018/11/7/e611ed53-c1d6-4fa9-b4a6-eaf8d7bb5e7e1541566511748-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-1.jpg",
    effectiveDiscountPercentageAfterTax: 58,
    effectiveDiscountAmountAfterTax: 870,
    inventoryInfo: [
      {
        skuId: 31274041,
        label: "28",
        inventory: 46,
        available: true,
      },
      {
        skuId: 31274042,
        label: "30",
        inventory: 155,
        available: true,
      },
      {
        skuId: 31274043,
        label: "32",
        inventory: 269,
        available: true,
      },
      {
        skuId: 31274044,
        label: "34",
        inventory: 203,
        available: true,
      },
      {
        skuId: 31274045,
        label: "36",
        inventory: 94,
        available: true,
      },
    ],
    sizes: "28,30,32,34,36",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/e611ed53-c1d6-4fa9-b4a6-eaf8d7bb5e7e1541566511748-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/e611ed53-c1d6-4fa9-b4a6-eaf8d7bb5e7e1541566511748-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/244af56a-374c-4638-a1e2-8c5d11d94cba1541566511662-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/3cf14655-6015-468a-af74-32f107e487a11541566511703-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/97a7d01c-7ac5-435b-99ed-09ab199a6de21541566511681-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/7139461/2018/11/7/9b82d554-5810-437f-a34a-15b08a4647631541566511721-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-1671541566511549-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(60% OFF)",
    additionalInfo: "Men Slim Fit Jeans",
    category: "Jeans",
    mrp: 1499,
    price: 599,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1541030400000",
    season: "Fall",
    year: "2018",
    systemAttributes: [],
  },
  {
    landingPageUrl: "Flip-Flops/Puma/Puma-Men-Black-Solid-Sliders/6816007/buy",
    id: 6816007,
    product: "Puma Men Black Solid Sliders",
    productName: "Puma Men Black Solid Sliders",
    rating: 0,
    ratingCount: 0,
    discount: 1500,
    brand: "Puma",
    searchImage:
      "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3a3279c9-abce-4b96-8864-d7235517b2711530602893936-Leadcat-5701530602892202-1.jpg",
    effectiveDiscountPercentageAfterTax: 58,
    effectiveDiscountAmountAfterTax: 1450,
    inventoryInfo: [
      {
        skuId: 30627112,
        label: "UK6",
        inventory: 95,
        available: true,
      },
      {
        skuId: 30627113,
        label: "UK7",
        inventory: 160,
        available: true,
      },
      {
        skuId: 30627114,
        label: "UK8",
        inventory: 229,
        available: true,
      },
      {
        skuId: 30627115,
        label: "UK9",
        inventory: 261,
        available: true,
      },
      {
        skuId: 30627116,
        label: "UK10",
        inventory: 193,
        available: true,
      },
      {
        skuId: 30627117,
        label: "UK11",
        inventory: 83,
        available: true,
      },
    ],
    sizes: "6,7,8,9,10,11",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3a3279c9-abce-4b96-8864-d7235517b2711530602893936-Leadcat-5701530602892202-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3a3279c9-abce-4b96-8864-d7235517b2711530602893936-Leadcat-5701530602892202-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/5c19184a-3dc4-45b3-a475-bb5e04049b0f1530602893876-Leadcat-5701530602892202-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/930ad3d2-548e-492f-950e-5d7d161b39841530602893908-Leadcat-5701530602892202-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/9345113b-bae9-402a-9a47-98349e3f031f1530602893890-Leadcat-5701530602892202-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/6816007/2018/7/3/3d184556-6b6b-4495-b6e0-edd4fac08cd41530602893923-Leadcat-5701530602892202-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(60% OFF)",
    additionalInfo: "Men Solid Sliders",
    category: "Flip Flops",
    mrp: 2499,
    price: 999,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1530144000000",
    season: "Fall",
    year: "2018",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Kurtas/Vishudh/Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta/2110558/buy",
    id: 2110558,
    product: "Vishudh Women Black & Gold-Toned Printed Straight Kurta",
    productName: "Vishudh Women Black & Gold-Toned Printed Straight Kurta",
    rating: 0,
    ratingCount: 0,
    discount: 575,
    brand: "Vishudh",
    searchImage:
      "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167748-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-1.jpg",
    effectiveDiscountPercentageAfterTax: 48,
    effectiveDiscountAmountAfterTax: 546,
    inventoryInfo: [
      {
        skuId: 14198620,
        label: "S",
        inventory: 678,
        available: true,
      },
      {
        skuId: 14198621,
        label: "M",
        inventory: 989,
        available: true,
      },
      {
        skuId: 14198622,
        label: "L",
        inventory: 1115,
        available: true,
      },
      {
        skuId: 14198623,
        label: "XL",
        inventory: 1172,
        available: true,
      },
      {
        skuId: 14198624,
        label: "XXL",
        inventory: 854,
        available: true,
      },
    ],
    sizes: "S,M,L,XL,XXL",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167748-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167748-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-1.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167681-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167722-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/2110558/2018/4/13/11523617167643-Vishudh-Women-Black--Gold-Toned-Printed-Straight-Kurta-9041523617167566-4.jpg",
      },
    ],
    gender: "Women",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(50% OFF)",
    additionalInfo: "Printed Straight Kurta",
    category: "Kurtas",
    mrp: 1149,
    price: 574,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1504742400000",
    season: "Winter",
    year: "2017",
    systemAttributes: [
      {
        attribute: "SA_XT_Trending",
        value: "TRENDING",
      },
    ],
  },
  {
    landingPageUrl:
      "Casual-Shoes/Mactree/Mactree-Men-Black-Sneakers/9620463/buy",
    id: 9620463,
    product: "Mactree Men Black Sneakers",
    productName: "Mactree Men Black Sneakers",
    rating: 0,
    ratingCount: 0,
    discount: 1190,
    brand: "Mactree",
    searchImage:
      "http://assets.myntassets.com/assets/images/productimage/2019/5/10/7cb3f96a-c680-494e-ae4a-0bd1963805fb1557442938198-1.jpg",
    effectiveDiscountPercentageAfterTax: 69,
    effectiveDiscountAmountAfterTax: 1165,
    inventoryInfo: [
      {
        skuId: 34310215,
        label: "UK6",
        inventory: 738,
        available: true,
      },
      {
        skuId: 34310216,
        label: "UK7",
        inventory: 920,
        available: true,
      },
      {
        skuId: 34310217,
        label: "UK8",
        inventory: 836,
        available: true,
      },
      {
        skuId: 34310218,
        label: "UK9",
        inventory: 824,
        available: true,
      },
      {
        skuId: 34310219,
        label: "UK10",
        inventory: 610,
        available: true,
      },
    ],
    sizes: "6,7,8,9,10",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/7cb3f96a-c680-494e-ae4a-0bd1963805fb1557442938198-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/7cb3f96a-c680-494e-ae4a-0bd1963805fb1557442938198-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/b4e03c15-99db-4fad-8031-19679cea00e11557442938289-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/79a38e22-2b4f-45ff-9449-623df84efdfd1557442938246-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/891c38bb-f230-4a2f-a889-f039e9050cf31557442938219-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/productimage/2019/5/10/cceaaf84-ff81-4077-a566-b0dcff0253561557442938266-4.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(70% OFF)",
    additionalInfo: "Men Sneakers",
    category: "Casual Shoes",
    mrp: 1699,
    price: 509,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1557360000000",
    season: "Spring",
    year: "2019",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Sweatshirts/Campus-Sutra/Campus-Sutra-Men-Black--Grey-Colourblocked-Hooded-Sweatshirt/10381447/buy",
    id: 10381447,
    product: "Campus Sutra Men Black & Grey Colourblocked Hooded Sweatshirt",
    productName:
      "Campus Sutra Men Black & Grey Colourblocked Hooded Sweatshirt",
    rating: 0,
    ratingCount: 0,
    discount: 880,
    brand: "Campus Sutra",
    searchImage:
      "http://assets.myntassets.com/assets/images/10381447/2019/8/16/3aaf0f72-0cf4-40ef-a36c-c81e3186c3281565956541245-Campus-Sutra-Men-Sweatshirts-2091565956539708-1.jpg",
    effectiveDiscountPercentageAfterTax: 53,
    effectiveDiscountAmountAfterTax: 844,
    inventoryInfo: [
      {
        skuId: 35459783,
        label: "S",
        inventory: 743,
        available: true,
      },
      {
        skuId: 35459791,
        label: "M",
        inventory: 348,
        available: true,
      },
      {
        skuId: 35459795,
        label: "L",
        inventory: 565,
        available: true,
      },
      {
        skuId: 35459799,
        label: "XL",
        inventory: 745,
        available: true,
      },
    ],
    sizes: "S,M,L,XL",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/3aaf0f72-0cf4-40ef-a36c-c81e3186c3281565956541245-Campus-Sutra-Men-Sweatshirts-2091565956539708-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/3aaf0f72-0cf4-40ef-a36c-c81e3186c3281565956541245-Campus-Sutra-Men-Sweatshirts-2091565956539708-1.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/aaf1e3b1-2d19-4efd-9d92-204d1612b5f31565956541174-Campus-Sutra-Men-Sweatshirts-2091565956539708-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/128f80d8-c789-4269-9f5e-d48e7ef882051565956541209-Campus-Sutra-Men-Sweatshirts-2091565956539708-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/d1f8718f-918c-4a31-b9da-9ee4062b54511565956541191-Campus-Sutra-Men-Sweatshirts-2091565956539708-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/10381447/2019/8/16/d0ea905f-b05b-4838-9f0a-32dd2f19433b1565956541227-Campus-Sutra-Men-Sweatshirts-2091565956539708-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(55% OFF)",
    additionalInfo: "Men Colourblocked Sweatshirt",
    category: "Sweatshirts",
    mrp: 1599,
    price: 719,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1565827200000",
    season: "Winter",
    year: "2019",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Kurta-Sets/Ahalyaa/Ahalyaa-Women-Black--Pink-Printed-Kurta-with-Palazzos/9689961/buy",
    id: 9689961,
    product: "Ahalyaa Women Black & Pink Printed Kurta with Palazzos",
    productName: "Ahalyaa Women Black & Pink Printed Kurta with Palazzos",
    rating: 0,
    ratingCount: 0,
    discount: 2318,
    brand: "Ahalyaa",
    searchImage:
      "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2ff8b66c-b9b0-4b17-8be6-6ab28a728fba1559027532069-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-1.jpg",
    effectiveDiscountPercentageAfterTax: 56,
    effectiveDiscountAmountAfterTax: 2140,
    inventoryInfo: [
      {
        skuId: 34363741,
        label: "S",
        inventory: 139,
        available: true,
      },
      {
        skuId: 34363742,
        label: "M",
        inventory: 161,
        available: true,
      },
      {
        skuId: 34363743,
        label: "L",
        inventory: 180,
        available: true,
      },
      {
        skuId: 34363744,
        label: "XL",
        inventory: 179,
        available: true,
      },
      {
        skuId: 34363745,
        label: "XXL",
        inventory: 189,
        available: true,
      },
    ],
    sizes: "S,M,L,XL,XXL",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2ff8b66c-b9b0-4b17-8be6-6ab28a728fba1559027532069-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2ff8b66c-b9b0-4b17-8be6-6ab28a728fba1559027532069-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-1.jpg",
      },
      {
        view: "top",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/2bc35be8-4cfc-407a-8f63-1e73e2b1f1ba1559027531935-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-6.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/93f0364d-34b8-4218-89fc-561c16070c5c1559027531956-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-5.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/7037fb77-0f74-44af-94cb-4ba0300db4031559027532013-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/ef082d8f-017c-49de-b727-ac35a6d247e41559027532041-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/9689961/2019/5/28/cc1354d3-4084-4ddf-b9be-ffb8127f5d4d1559027531981-Ahalyaa-Women-Black-Printed-Kurta-with-Palazzos-358155902753-4.jpg",
      },
    ],
    gender: "Women",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(61% OFF)",
    additionalInfo: "Women Printed Kurta with Palazzos",
    category: "Kurta Sets",
    mrp: 3799,
    price: 1481,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1558569600000",
    season: "Summer",
    year: "2019",
    systemAttributes: [],
  },
  {
    landingPageUrl:
      "Jeans/HERENOW/HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans/9211679/buy",
    id: 9211679,
    product:
      "HERE&NOW Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    productName:
      "HERE&NOW Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    rating: 0,
    ratingCount: 0,
    discount: 1320,
    brand: "HERE&NOW",
    searchImage:
      "http://assets.myntassets.com/assets/images/9211679/2019/7/15/14f9566a-c584-4101-86f3-bc54a91d4cce1563190986058-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-1.jpg",
    effectiveDiscountPercentageAfterTax: 58,
    effectiveDiscountAmountAfterTax: 1276,
    inventoryInfo: [
      {
        skuId: 33916416,
        label: "28",
        inventory: 51,
        available: true,
      },
      {
        skuId: 33916418,
        label: "30",
        inventory: 104,
        available: true,
      },
      {
        skuId: 33916421,
        label: "32",
        inventory: 69,
        available: true,
      },
      {
        skuId: 33916423,
        label: "34",
        inventory: 13,
        available: true,
      },
      {
        skuId: 33916425,
        label: "36",
        inventory: 13,
        available: true,
      },
    ],
    sizes: "28,30,32,34,36",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/14f9566a-c584-4101-86f3-bc54a91d4cce1563190986058-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/14f9566a-c584-4101-86f3-bc54a91d4cce1563190986058-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-1.jpg",
      },
      {
        view: "top",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/79ee951f-4c4e-48c5-b6c4-91641909467d1563190985945-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-6.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/ad8cc0ef-2fa0-4bc3-aa27-5532ebbed7741563190985970-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-5.jpg",
      },
      {
        view: "bottom",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/659c12dc-8739-4ed1-9696-51c60eca31331563190985928-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-7.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/114bdd54-af07-495c-ad68-969d0b9073d11563190986011-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-3.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/802aaa6d-6fd9-40f2-b026-d2780fad08dc1563190985989-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-4.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/9211679/2019/7/15/8eda8dab-5f45-4c09-80d6-4d417bfe34c61563190986036-HERENOW-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-J-2.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(60% OFF)",
    additionalInfo: "Men Slim Fit Jeans",
    category: "Jeans",
    mrp: 2199,
    price: 879,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1560384000000",
    season: "Summer",
    year: "2019",
    systemAttributes: [
      {
        attribute: "SA_XT_Trending",
        value: "TRENDING",
      },
    ],
  },
  {
    landingPageUrl:
      "Jeans/Roadster/Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans/7139482/buy",
    id: 7139482,
    product:
      "Roadster Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    productName:
      "Roadster Men Black Slim Fit Mid-Rise Clean Look Stretchable Jeans",
    rating: 0,
    ratingCount: 0,
    discount: 450,
    brand: "Roadster",
    searchImage:
      "http://assets.myntassets.com/assets/images/7139482/2018/11/20/67238d5c-8749-47b5-a4e1-732aedc885d91542713378025-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-1.jpg",
    effectiveDiscountPercentageAfterTax: 22,
    effectiveDiscountAmountAfterTax: 324,
    inventoryInfo: [
      {
        skuId: 31274146,
        label: "28",
        inventory: 287,
        available: true,
      },
      {
        skuId: 31274147,
        label: "30",
        inventory: 289,
        available: true,
      },
      {
        skuId: 31274148,
        label: "32",
        inventory: 92,
        available: true,
      },
      {
        skuId: 31274149,
        label: "34",
        inventory: 25,
        available: true,
      },
      {
        skuId: 31274150,
        label: "36",
        inventory: 1,
        available: true,
      },
    ],
    sizes: "28,30,32,34,36",
    images: [
      {
        view: "default",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/67238d5c-8749-47b5-a4e1-732aedc885d91542713378025-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-1.jpg",
      },
      {
        view: "search",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/67238d5c-8749-47b5-a4e1-732aedc885d91542713378025-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-1.jpg",
      },
      {
        view: "top",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/595f1c50-a411-4a9d-b19c-18eb216878ea1542713377948-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-6.jpg",
      },
      {
        view: "left",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/e9d42c7f-8f30-4aa1-abf2-e9473acdad7c1542713377961-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-5.jpg",
      },
      {
        view: "bottom",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/0572b7c4-7cc4-4f25-9413-76e8b2725a691542713377937-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-7.jpg",
      },
      {
        view: "back",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/63837c12-619d-45fa-8670-17abd0c09ba11542713377996-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-3.jpg",
      },
      {
        view: "front",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/c9deaae0-0f50-430d-abe0-214b8a589b931542713378012-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-2.jpg",
      },
      {
        view: "right",
        src: "http://assets.myntassets.com/assets/images/7139482/2018/11/20/3d37fb1a-4ce0-42e2-adc6-f7bfbad531691542713377979-Roadster-Men-Black-Slim-Fit-Mid-Rise-Clean-Look-Stretchable-Jeans-9171542713377845-4.jpg",
      },
    ],
    gender: "Men",
    primaryColour: "Black",
    discountLabel: "Flat_Search_Percent",
    discountDisplayLabel: "(30% OFF)",
    additionalInfo: "Men Slim Fit Jeans",
    category: "Jeans",
    mrp: 1499,
    price: 1049,
    colorVariantAvailable: false,
    discountType: "1",
    catalogDate: "1542240000000",
    season: "Fall",
    year: "2018",
    systemAttributes: [],
  },
];
console.log(NewArivel[0].images[0].src)
export default NewArivel;
